import App from "./components/App";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";

const title = "Ktext";

const rootElement = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

initializeIcons();
var msalConfig = fetch("KWord3Config.js")
  .then((response) => response.text())
  .then((code) => {
    // Create a script element and insert the code
    const script = document.createElement("script");
    script.innerHTML = code;
    document.head.appendChild(script);
    // Now you can access the variables from the fetched script

    const msalConfig = {
      auth: {
        clientId: APP_ClientId,
        authority: "https://login.microsoftonline.com/" + APP_TenantId, // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
        redirectUri: APP_SiteUrl,
        postLogoutRedirectUri: APP_SiteUrl + "logout.html",
      },
      cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
      },
    };
    return msalConfig;
  })
  .catch((error) => {
    console.error("Error fetching KWord3Config.js:", error);
  });

const msalInstance = new PublicClientApplication(msalConfig);

/* Render application after Office initializes */
Office.onReady(() => {
  root?.render(
    <MsalProvider instance={msalInstance}>
      <App title={title} />
    </MsalProvider>
  );
});

if (module.hot) {
  module.hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(NextApp);
  });
}
